import { IoWarningOutline } from "react-icons/io5";

export function Alert({message}: {message:string}) {
    const alertStyle: React.CSSProperties = {
        width: "560px",
        backgroundColor: "#eba983fc",
        borderRadius: "4px",
        fontFamily: "Arial",
        fontSize: "12px",
        color: "white",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        border: "1.5px solid yellow",
        boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.2)",
        backdropFilter: "blur(10px)",
    }
    const iconStyle: React.CSSProperties = {
        fontSize: "26px",
        marginRight: "16px",
        color: "yellow"
    };
    return (
        <div style={alertStyle}>
            <IoWarningOutline style={iconStyle}/>
            <p>{message}</p>
        </div>
    )
}